export var HistoryCurveDisplayPeriodEnum;
(function (HistoryCurveDisplayPeriodEnum) {
    HistoryCurveDisplayPeriodEnum[HistoryCurveDisplayPeriodEnum["RecentAnHour"] = 1] = "RecentAnHour";
    HistoryCurveDisplayPeriodEnum[HistoryCurveDisplayPeriodEnum["RecentOneDay"] = 2] = "RecentOneDay";
    HistoryCurveDisplayPeriodEnum[HistoryCurveDisplayPeriodEnum["RecentSevenDays"] = 3] = "RecentSevenDays";
    HistoryCurveDisplayPeriodEnum[HistoryCurveDisplayPeriodEnum["RecentThirtyDays"] = 4] = "RecentThirtyDays";
    HistoryCurveDisplayPeriodEnum[HistoryCurveDisplayPeriodEnum["RecentOneYear"] = 5] = "RecentOneYear";
})(HistoryCurveDisplayPeriodEnum || (HistoryCurveDisplayPeriodEnum = {}));
